export const setToHTMLBody = (body: string, header: string = '', footer: string = '', extraBodyStyle: string = '') => {
    return `
    <!doctype html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>HTML2PDF</title>
    <script src="https://cdn.tailwindcss.com"></script>
    <script>
      tailwind.config = {
          theme: {
              extend: {
                  fontFamily: {
                      sans: ['Helvetica', 'Arial', 'sans-serif'],
                  },
              },
          },
      };
    </script>
    <style>
       html,
        body {
            height: 100% !important;
            ${extraBodyStyle}
        }

        body {
            @apply font-sans;
        }

        td {
            word-break: break-word !important; 
        }

        .suneditor ol,
        .suneditor ul {
            list-style-position: outside;
            display: block;
            margin-block-start: 1em;
            margin-block-end: 1em;
            margin-inline-start: 0;
            margin-inline-end: 0;
            padding-inline-start: 40px;
        }

        .suneditor ol {
            list-style-type: decimal;
        }

        .suneditor ul {
          list-style-type: disc;
        }

        .suneditor table {
            display: table;
            table-layout: auto !important;
            border: 1px solid #ccc;
            width: 100%;
            max-width: 100%;
            margin: 0 0 10px;
            background-color: transparent;
            border-spacing: 0;
            border-collapse: collapse;
        }

        .suneditor tr {
            display: table-row;
            vertical-align: inherit;
            unicode-bidi: isolate;
            border: 1px solid #efefef;
        }

        .suneditor tbody {
            display: table-row-group;
            vertical-align: middle;
            unicode-bidi: isolate;
            border-color: inherit;
        }

        .suneditor li {
            display: list-item;
            text-align: -webkit-match-parent;
            margin-bottom: 5px;
        }

        .suneditor th {
            border: 1px solid #e1e1e1;
            padding: .4em;
            background-clip: padding-box;
        }

        .suneditor td {
            border: 1px solid #e1e1e1;
            padding: .4em;
            background-clip: padding-box;
        }

        @media print {
            .page-break {
                page-break-before: always;
                break-before: page;
                height: 100%;
            }
        }

        .suneditor blockquote {
            display: block;
            font-family: inherit;
            font-size: inherit;
            color: #999;
            margin-block-start: 1em;
            margin-block-end: 1em;
            margin-inline-start: 0;
            margin-inline-end: 0;
            padding: 0 5px 0 20px;
            border: solid #b1b1b1;
            border-width: 0 0 0 5px;
        }

        .suneditor pre {
            display: block;
            padding: 8px;
            margin: 0 0 10px;
            font-family: monospace;
            color: #666;
            line-height: 1.45;
            background-color: #f9f9f9;
            border: 1px solid #e1e1e1;
            border-radius: 2px;
            white-space: pre-wrap !important;
            word-wrap: break-word;
            overflow: visible;
        }

        .suneditor p {
            display: block;
            margin-block-start: 1em;
            margin-block-end: 1em;
            margin-inline-start: 0px;
            margin-inline-end: 0px;
            unicode-bidi: isolate;
        }

        .suneditor h1 {
            display: block;
            font-size: 2em;
            margin-block-start: 0.67em;
            margin-block-end: 0.67em;
            margin-inline-start: 0px;
            margin-inline-end: 0px;
            font-weight: bold;
            unicode-bidi: isolate;
        }

        .suneditor h2 {
            display: block;
            font-size: 1.5em;
            margin-block-start: 0.83em;
            margin-block-end: 0.83em;
            margin-inline-start: 0px;
            margin-inline-end: 0px;
            font-weight: bold;
            unicode-bidi: isolate;
        }

        .suneditor h3 {
            display: block;
            font-size: 1.17em;
            margin-block-start: 1em;
            margin-block-end: 1em;
            margin-inline-start: 0px;
            margin-inline-end: 0px;
            font-weight: bold;
            unicode-bidi: isolate;
        }

        .suneditor h4 {
            display: block;
            margin-block-start: 1.33em;
            margin-block-end: 1.33em;
            margin-inline-start: 0px;
            margin-inline-end: 0px;
            font-weight: bold;
            unicode-bidi: isolate;
        }

        .suneditor h5 {
            display: block;
            font-size: 0.83em;
            margin-block-start: 1.67em;
            margin-block-end: 1.67em;
            margin-inline-start: 0px;
            margin-inline-end: 0px;
            font-weight: bold;
            unicode-bidi: isolate;
        }

        .suneditor h6 {
            display: block;
            font-size: 0.67em;
            margin-block-start: 2.33em;
            margin-block-end: 2.33em;
            margin-inline-start: 0px;
            margin-inline-end: 0px;
            font-weight: bold;
            unicode-bidi: isolate;
        }

        .suneditor hr {
            display: flex;
            border-width: 1px 0 0;
            border-color: #000;
            border-image: initial;
            height: 1px;
            margin-top: 6.5px;
            margin-bottom: 6.5px;
        }

        .suneditor .__se__dotted {
            border-style: dotted none none;
        }

        .suneditor .on {
            border-color: #4592ff;
            box-shadow: 0 0 0 .1rem #c7deff;
        }

        .suneditor .__se__dashed {
            border-style: dashed none none;
        }

        .suneditor .__se__solid {
            border-style: solid none none;
        }

    </style>
  </head>

  <body class="relative font-sans">
    <div class="absolute top-4 left-0 right-0">${header}</div>
    ${body}
    <div class="absolute bottom-4 left-0 right-0">${footer}</div>
  </body>
</html>
    `
};

export const buildSunEditor = (htmlContent: string) => {
    return `
  <!DOCTYPE html>
<html lang="en">

<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>SunEditor Readonly</title>

    <link href="https://cdn.jsdelivr.net/npm/suneditor@latest/dist/css/suneditor.min.css" rel="stylesheet">
    <!-- <link href="https://cdn.jsdelivr.net/npm/suneditor@latest/assets/css/suneditor.css" rel="stylesheet"> -->
    <!-- <link href="https://cdn.jsdelivr.net/npm/suneditor@latest/assets/css/suneditor-contents.css" rel="stylesheet"> -->
    <script src="https://cdn.jsdelivr.net/npm/suneditor@latest/dist/suneditor.min.js"></script>
    <!-- languages (Basic Language: English/en) -->
    <script src="https://cdn.jsdelivr.net/npm/suneditor@latest/src/lang/ko.js"></script>

    <style>
        .sun-editor {
            border: unset;
        }

        .sun-editor-editable {
            padding: 0px;
        }
    </style>
</head>

<body>

    <div id="editor"></div>

    <script>
        // Ensure the script is fully loaded
        window.addEventListener("load", function () {
            if (window.SUNEDITOR) {
                const editor = SUNEDITOR.create(document.getElementById("editor"), {
                    placeholder: "",
                    value: "${JSON.stringify(htmlContent)}",
                    buttonList: [],
                    mode: "inline",
                    hideToolbar: true,
                    disabled: true,
                    defaultStyle: "font-family: Helvetica;"
                });
            } else {
                console.error("SunEditor is not loaded");
            }
        });
    </script>

</body>

</html>
  
  `;
};

export const setToHTMLBodyWithGoogleChart = (body: string, script: string = '') => {
    return `
<!doctype html>
<html lang="en">
    <head>
        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>HTML2PDF</title>
        <script src="https://cdn.tailwindcss.com"></script>
        <script type="text/javascript" src="https://www.gstatic.com/charts/loader.js"></script>
        <script>
        tailwind.config = {
            theme: {
                extend: {
                    fontFamily: {
                        sans: ['Helvetica', 'Arial', 'sans-serif'],
                    },
                },
            },
        };
        </script>
        ${script}
        <style>
        html,
            body {
                height: 100% !important;
            }

            body {
                @apply font-sans;
            }

            td {
                word-break: break-word !important; 
            }

            @media print {
                .page-break {
                    page-break-before: always;
                    break-before: page;
                    height: 100%;
                }
            }

            .chart-container {
                margin-top: 20px; /* Adjust the margin as needed */
            }

        </style>
    </head>

    <body class="relative font-sans">
        ${body}
    </body>
</html>
    `
};